﻿import $ from "jquery";
import require from "require";
import Program from "./Program";

export default class Lightbox extends Program {
	constructor() {
		require("Fancybox");

		super(...arguments);

		this.config = {
			touch: false,
			smallBtn: false,
			baseClass: "ccs-logo-lightbox",
			beforeShow: () => this.resize(),
			afterClose: () => this.close()
	};

		this.param = this.$icon.attr("data-logo-param");

		if (!this.param) {
			this.initMobileConfig();
		} else {
			this.initImageConfig();
		}

		this.initIconClick();
	}

	initImageConfig() {
		this.config.type = "image";
		this.config.src = this.param;
	}

	initMobileConfig() {
		this.config.type = "html";
		this.config.content = this.$popup;

		this.resize = this.resizeMobile;

		this.maxWidth = this.$popup.outerWidth(true);
	}

	resizeMobile() {
		if (this.maxWidth !== 0 && window.outerWidth > this.maxWidth) {
			this.$popup.outerWidth(this.maxWidth);
		} else {
			this.$popup.outerWidth("auto");
		}
	}

	openPopup() {
		$.fancybox.open(this.config);
	}
}